import styled from "styled-components";

const svgPrefix =
  'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="%23ff373c" color="%23ff373c">';
const svgSuffix = "</path></svg>";

export const ArticleBodyStyles = styled.div(({ theme }) => ({
  "& a": {
    color: "inherit",

    "&:hover": {
      color: theme.palette.primary.main,
      textDecoration: "none",
    },
  },

  // basic styling for hr
  "& hr": {
    border: `1px solid ${theme.palette.grey[200]}`,
    borderWidth: "1px 0 0 0",
    margin: "32px 0",
  },

  // ensure images don't overflow
  "& img": {
    maxWidth: "100%",
  },

  // basic heading styling
  "& h1, & h2, & h3, & h4": {
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.getColorVariantCSSColor("neutralDark"),
    // overwrite for any heading with <b> tags
    "& b": {
      fontWeight: 600,
    },
  },

  "& h4": {
    fontSize: 14,
  },

  // accordion
  "& details": {
    "& summary": {
      borderTop: `1px solid ${theme.palette.grey[200]}`,
      minHeight: 48,
      cursor: "pointer",
      padding: "12px 0",

      "& > h2,  & > h3": {
        position: "relative",
        fontSize: 14,
        fontWeight: 600,
        margin: "12px 0 !important",

        // open (+) icon
        "&::after": {
          position: "absolute",
          content: '""',
          top: "-12px",
          right: "-12px",
          borderRadius: "50%",
          height: 48,
          width: 48,
          transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          background: `no-repeat center center url('${svgPrefix}<path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z">${svgSuffix}')`,
        },
      },

      // hide default arrow
      "&::marker": {
        content: "none",
      },
      "&::-webkit-details-marker": {
        display: "none",
      },

      "&:hover > h2::after, &:hover > h3::after": {
        backgroundColor: theme.palette.grey[100],
      },
    },
    "&:last-of-type": {
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
      marginBottom: 32,
    },
    // close (-) icon
    "&[open] > summary > h2:after, &[open] > summary > h3:after": {
      transform: "rotate(180deg)",
      backgroundImage: `url('${svgPrefix}<path d="M19 13H5v-2h14v2z">${svgSuffix}')`,
    },
  },

  // existing CSS
  "& table": {
    borderCollapse: "collapse",
    border: `1px solid ${theme.palette.grey[200]}`,
  },

  "& td": {
    verticalAlign: "top",
    textAlign: "left",
    padding: 5,
    p: {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
  },
  "& blockquote": {
    padding: 10,
    backgroundColor: theme.palette.grey[100],
    borderLeft: 10,
    borderLeftStyle: "solid",
    borderLeftColor: theme.palette.grey[200],
    marginBlockStart: 0,
    marginBlockEnd: 0,
    marginInlineStart: 0,
    marginInlineEnd: 0,

    "& h3": {
      marginTop: 0,
      marginBottom: 4,
    },

    "& p": {
      marginTop: 4,
      marginBottom: 4,
    },
  },
}));
